import { el } from '../state/store.js';

/* THE REAL LOGO, for the surfaces that are not the topbar.

   The admin screens used to draw their own lockup: the mark beside "Illusio"
   and a bold "3D" set in whatever face the UI happens to use — an
   approximation, which the topbar already stopped being (its own comment: the
   drawn wordmark is the real one, with its letter spacing and the weight of the
   3D). This is the same two files the topbar uses, swapped by theme the same
   way, so the admin pages carry the brand rather than a text imitation of it.

   TWO FILES, not one recoloured — see the note above .brand .logo in app.css:
   a blue mark and a wordmark that has to read on either ground cannot be done
   with a filter. Sized by CSS (.alogo__img) so each surface can set its own
   height; the intrinsic size is given so the layout does not jump on load. */
export function logoLockup() {
  const wrap = el('span', 'alogo');
  for (const [variant, src] of [['dark', '/illusio-logo-white.png'], ['light', '/illusio-logo-black.png']]) {
    const img = el('img', 'alogo__img alogo__img--' + variant);
    img.src = src;
    img.alt = 'Illusio 3D';
    img.width = 428; img.height = 100;
    wrap.appendChild(img);
  }
  return wrap;
}
